import React from 'react';
import { ToggleWrapper } from './ToggleItem.styles';
import type { TextV2Props } from '../../../TextV2';
import { TextV2 } from '../../../TextV2';
import { pxToRem } from '@withjoy/joykit/theme';
import classNames from 'classnames';
import type { SegmentedControllerVariant } from '../../SegmentedController.types';

export type ToggleItemProps = Readonly<{
  label: string;
  value: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  isActive?: boolean;
  isDisabled?: boolean;
  isMobile?: boolean;
  textProps?: TextV2Props;
  variant?: SegmentedControllerVariant;
}>;

const UNDERLINE_TEXT_PROPS: TextV2Props = {
  typographyVariant: 'button2',
  fontSize: pxToRem(15),
};

const PILL_TEXT_PROPS: TextV2Props = {
  typographyVariant: 'body1',
};

const ToggleItem: React.FC<ToggleItemProps> = ({ onClick, isActive, value, isMobile, textProps = {}, isDisabled, variant }) => {
  const isUnderline = variant === 'underline';
  const baseTextProps = isUnderline ? UNDERLINE_TEXT_PROPS : PILL_TEXT_PROPS;
  const inactiveColor = isUnderline ? 'mono8' : 'mono10';

  return (
    <ToggleWrapper
      as="a"
      isMobile={isMobile}
      variant={variant}
      onClick={isDisabled ? undefined : onClick}
      className={classNames({ active: isActive, disabled: isDisabled })}
    >
      <TextV2
        color={isActive ? 'mono14' : inactiveColor}
        {...baseTextProps}
        {...textProps}
      >
        {value}
      </TextV2>
    </ToggleWrapper>
  );
};

export { ToggleItem };
